var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/Assignee.ts";
import * as t from 'io-ts';
import { AssigneeSource } from './assigneeSource.enum';
export var Assignee = t.type({
  assigneeId: t.string,
  source: t.union([t.literal(AssigneeSource.USER), t.literal(AssigneeSource.ROLE), t.literal(AssigneeSource.COMPANY)])
});